import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const BlogsDetails1 = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <section id="center" class="center_o bg-black p_3">
        <div class="container-xl">
          <div class="row center_o1">
            <div class="col-md-12">
              <h2 class="text-white">Blog Detail</h2>
              <h6 class="mb-0 mt-3 col_yell">
                <a class="text-white" href="#">
                  Home
                </a>{" "}
                <span class="mx-2 text-muted">/</span> Blog Detail
              </h6>
            </div>
          </div>
        </div>
      </section>

      <section id="blog" class="p_3">
        <div class="container-xl">
          <div class="row blog_1">
            <div class="col-md-8">
              <div class="blog_1dt">
                <div class="blog_1dt1">
                  <div class="grid clearfix">
                    <figure class="effect-jazz mb-0">
                     
                        <img
                          src="https://img.freepik.com/free-photo/html-css-collage-concept-with-person_23-2150062008.jpg"
                          class="w-100"
                          alt="abc"
                        />
                      
                    </figure>
                  </div>
                  <h6 class="fw-bold col_yell mt-3 mb-3">
                    Software Development
                  </h6>
                  <h6 class="mb-0 font_14">
                    <i class="fa fa-calendar col_yell me-1"></i> 30 November
                    2024
                    <i class="fa fa-user col_yell me-1 ms-3"></i> KH Hridoy
                  </h6>
                  <h3 class="mt-3">
                    Web and App Development: The Crucial Role of JavaScript
                  </h3>
                  <p>
                    JavaScript is at the heart of modern web and app
                    development, enabling developers to create dynamic,
                    interactive, and user-friendly interfaces. It is a versatile
                    language that powers both the front end and back end of
                    applications, making it indispensable for software
                    development.
                  </p>

                  <h5 class="mt-4">
                    The Ubiquity of JavaScript in Web Development
                  </h5>
                  <p>
                    JavaScript is widely used to build responsive websites that
                    adapt seamlessly to various devices and screen sizes. With
                    frameworks like React, Angular, and Vue.js, developers can
                    create complex web applications with ease.
                  </p>

                  <h5 class="mt-4">JavaScript in Mobile App Development</h5>
                  <p>
                    Beyond the web, JavaScript has become a key player in mobile
                    app development. Frameworks like React Native and Ionic
                    allow developers to build cross-platform apps that work
                    seamlessly on both iOS and Android, reducing development
                    time and cost.
                  </p>

                  <h5 class="mt-4">Back-end Development with Node.js</h5>
                  <p>
                    JavaScript isn't limited to the front end; it also powers
                    back-end development through platforms like Node.js. With
                    Node.js, developers can build scalable, high-performance
                    server-side applications, streamlining the development
                    process with a single language for both client and server.
                  </p>

                  <h5 class="mt-4">
                    The Importance of JavaScript in Emerging Technologies
                  </h5>
                  <p>
                    JavaScript plays a crucial role in the development of
                    emerging technologies such as Progressive Web Apps (PWAs),
                    Artificial Intelligence (AI), and the Internet of Things
                    (IoT). Its flexibility and extensive libraries make it a
                    preferred choice for innovative projects.
                  </p>

                  <h5 class="mt-4">Future Trends in JavaScript Development</h5>
                  <p>
                    The future of JavaScript lies in its continuous evolution
                    and the adoption of modern tools and practices. From
                    TypeScript to WebAssembly, JavaScript is becoming more
                    powerful and efficient, enabling developers to push the
                    boundaries of what’s possible.
                  </p>

                  <h5 class="mt-4">Conclusion</h5>
                  <p>
                    In conclusion, JavaScript remains the cornerstone of web and
                    app development. Its versatility, scalability, and wide
                    range of use cases make it an essential skill for developers
                    in the ever-changing software development landscape.
                  </p>
                </div>

                {/* <div class="blog_1dt2 mt-5">
                  <h2 class="mb-3">Related Post</h2>
                  <div class="story_1 row">
                    <div class="col-md-6">
                      <div class="story_1l shadow_box p-2">
                        <div class="story_1l1 position-relative">
                          <div class="story_1l1i">
                            <div class="grid clearfix">
                              <figure class="effect-jazz mb-0">
                               <Link to="/blog-details2">
                                  <img
                                    src="https://img.freepik.com/free-photo/asian-businesswoman-sitting-desk-office-studying-graphs-large-computer-screen_1098-20500.jpg"
                                    class="w-100"
                                    alt="abc"
                                  />
                                </Link>
                              </figure>
                            </div>
                          </div>
                          <div class="story_1l1i1 position-absolute text-end w-100 px-3">
                            <img
                              src="https://www.datafluent.xyz/assets/img/dfa/noman.jpg"
                              class="rounded-circle"
                              width="60"
                              height="60"
                              alt="abc"
                            />
                          </div>
                        </div>
                        <div class="story_1l mt-4 px-3 pb-3">
                          <h6 class="fw-bold col_yell">Data Analytics</h6>
                          <h5 class="mt-3">
                            <Link to="/blog-details2"> 
                              The Power of Data Visualization: Unveiling
                              Insights Beyond Numbers
                            </Link>
                          </h5>
                          <p>
                            In the age of information overload, data has become
                            the lifeblood of decision-making and problem-solving
                            in every industry.
                          </p>
                          <h6 class="mb-0 font_14">
                            <i class="fa fa-calendar col_yell me-1"></i> 11
                            March 2024{" "}
                            <i class="fa fa-user col_yell me-1 ms-3"></i>
                            Md Abdullah Al Noman
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="story_1l shadow_box p-2">
                        <div class="story_1l1 position-relative">
                          <div class="story_1l1i">
                            <div class="grid clearfix">
                              <figure class="effect-jazz mb-0">
                                <Link to="/blog-details4">
                                  <img
                                    src="https://img.freepik.com/free-photo/html-css-collage-concept-with-person_23-2150061993.jpg"
                                    class="w-100"
                                    alt="abc"
                                  />
                                </Link>
                              </figure>
                            </div>
                          </div>
                          <div class="story_1l1i1 position-absolute text-end w-100 px-3">
                            <img
                              src="https://www.datafluent.xyz/assets/img/blog/sarwar.jpeg"
                              class="rounded-circle"
                              width="60"
                              height="60"
                              alt="abc"
                            />
                          </div>
                        </div>
                        <div class="story_1l mt-4 px-3 pb-3">
                          <h6 class="fw-bold col_yell">Data Engineering</h6>
                          <h5 class="mt-3">
                            <Link to="/blog-details4">
                              Navigating the Data Deluge: The Power of Data
                              Engineering
                            </Link>
                          </h5>
                          <p>
                            In the digital age, data is not just a commodity;
                            it's a strategic asset. Every click, swipe, and
                            transaction generates
                          </p>
                          <h6 class="mb-0 font_14">
                            <i class="fa fa-calendar col_yell me-1"></i> 15
                            February 2023{" "}
                            <i class="fa fa-user col_yell me-1 ms-3"></i>Md
                            Sarwar Jahan
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}

                
              </div>
            </div>
            <div class="col-md-4">
              <div class="blog_1r">
                <div className="blog_1r1 shadow_box p-4">
                  <h4 className="mb-3">Categories</h4>
                  <h6>
                    <Link to="#">
                      <i className="fa fa-chevron-right col_yell me-1 font_12"></i>
                      Data Analytics
                    </Link>
                  </h6>
                  <hr />
                  <h6>
                    <Link to="#">
                      <i className="fa fa-chevron-right col_yell me-1 font_12"></i>
                      Artificial Intelligence
                    </Link>
                  </h6>
                  <hr />
                  <h6>
                    <Link to="#">
                      <i className="fa fa-chevron-right col_yell me-1 font_12"></i>
                      Machine Learning
                    </Link>
                  </h6>
                  <hr />
                  <h6>
                    <Link to="#">
                      <i className="fa fa-chevron-right col_yell me-1 font_12"></i>
                      Cloud Computing
                    </Link>
                  </h6>
                  <hr />
                  <h6 className="mb-0">
                    <Link to="#">
                      <i className="fa fa-chevron-right col_yell me-1 font_12"></i>
                      Business Intelligence
                    </Link>
                  </h6>
                </div>

                <div class="blog_1r1 shadow_box p-4 mt-4">
                  <h4 class="mb-3">Recent Post</h4>

                 <div class="blog_1r1i row">
                    <div class="col-md-4  col-4">
                      <div class="blog_1r1il">
                        <div class="grid clearfix">
                          <figure class="effect-jazz mb-0">
                            <Link to="/blog-Details">
                              <img
                                src="https://img.freepik.com/free-photo/engineers-brainstorming-ways-use-ai_482257-84889.jpg"
                                class="w-100"
                                alt="abc"
                              />
                            </Link>
                          </figure>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8 col-8">
                      <div class="blog_1r1ir">
                        <h6>
                          <Link to="/blog-Details">
                            Revolutionizing Data Analytics with AI and Machine
                            Learning
                          </Link>
                        </h6>
                        <h6 class="text-muted font_14 fw-normal mb-0">
                          <i class="fa fa-clock-o col_yell me-1"></i> 25 May,
                          2024 <i class="fa fa-comment col_yell me-1 ms-2"></i>{" "}
                          4 Comments
                        </h6>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="blog_1r1i row">
                    <div class="col-md-4  col-4">
                      <div class="blog_1r1il">
                        <div class="grid clearfix">
                          <figure class="effect-jazz mb-0">
                            <Link to="/blog-Details2">
                              <img
                                src="https://img.freepik.com/free-photo/asian-businesswoman-sitting-desk-office-studying-graphs-large-computer-screen_1098-20500.jpg"
                                class="w-100"
                                alt="abc"
                              />
                            </Link>
                          </figure>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8 col-8">
                      <div class="blog_1r1ir">
                        <h6>
                          <Link to="/blog-Details2">
                            The Power of Data Visualization: Unveiling Insights
                            Beyond Numbers
                          </Link>
                        </h6>
                        <h6 class="text-muted font_14 fw-normal mb-0">
                          <i class="fa fa-clock-o col_yell me-1"></i> 11 March,
                          2024 <i class="fa fa-comment col_yell me-1 ms-2"></i>{" "}
                          3 Comments
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="blog_1r1 shadow_box p-4 mt-4">
                  <h4 class="mb-3">Tags</h4>
                  <ul className="mb-0 tags">
                    <li className="d-inline-block">
                      <Link to="#">Data Analytics</Link>
                    </li>
                    <li className="d-inline-block">
                      <Link to="#">Artificial Intelligence</Link>
                    </li>
                    <li className="d-inline-block">
                      <Link to="#">Machine Learning</Link>
                    </li>
                    <li className="d-inline-block">
                      <Link to="#">Data Science</Link>
                    </li>
                    <li className="d-inline-block">
                      <Link to="#">Cloud Computing</Link>
                    </li>
                    <li className="d-inline-block">
                      <Link to="#">Big Data</Link>
                    </li>
                  </ul>
                </div>

                {/* <div class="blog_1r1 shadow_box p-4 mt-4">
                  <h4 class="mb-3">Newsletter</h4>
                  <p class="center_sm">Sign Up for Our Newsletter!</p>
                  <input
                    class="form-control"
                    placeholder="Subscribe"
                    type="text"
                  />
                  <h6 class="mb-0 mt-3 center_sm">
                    <a class="button" href="blog_detail.html">
                      Subscribe
                    </a>
                  </h6>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogsDetails1;
